import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de2e5b95142159/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/node_modules/next/dist/client/link.js");
